import { formatCurrency, transformDateToLocalDateString } from "helpers";
import { OpenInvoiceRow, ReceivablesReport } from "services/api/reports/finance/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";

export const OPEN_INVOICE_COLUMNS: Column[] = [
  {
    title: "Broj",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) => (
      <div className="text-sm font-medium text-slate-800">{row.invoiceNumber ?? "—"}</div>
    ),
  },
  {
    title: "Kupac",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) => (
      <div className="text-sm text-slate-700 truncate">{row.clientName ?? "—"}</div>
    ),
  },
  {
    title: "Vozilo",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) => (
      <div className="text-sm text-slate-500">{row.vehicleName ?? "—"}</div>
    ),
  },
  {
    title: "Datum",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) => (
      <div className="text-sm text-slate-500">
        {row.invoiceDate ? transformDateToLocalDateString(new Date(row.invoiceDate)) : "—"}
      </div>
    ),
  },
  {
    title: "Dospijeće",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) => (
      <div className="text-sm text-slate-500">
        {row.dueDate ? transformDateToLocalDateString(new Date(row.dueDate)) : "—"}
      </div>
    ),
  },
  {
    title: "Iznos",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) => (
      <div className="text-sm font-semibold text-slate-800">
        {formatCurrency.format(row.amount)}
      </div>
    ),
  },
  {
    title: "Kašnjenje",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OpenInvoiceRow) =>
      row.daysOverdue > 0 ? (
        <Badge
          text={`${row.daysOverdue} dana`}
          variant={row.daysOverdue > 60 ? "danger" : "warning"}
          height="small"
          showDot
        />
      ) : (
        <Badge text="U roku" variant="success" height="small" showDot />
      ),
  },
];

export interface ReceivablesKpi {
  label: string;
  value: string;
  valueClass: string;
}

/** Četiri brojke u zaglavlju taba; redoslijed prati put novca od računa do naplate. */
export const buildReceivablesKpis = (data: ReceivablesReport): ReceivablesKpi[] => [
  {
    label: "Fakturirano",
    value: formatCurrency.format(data.invoiced),
    valueClass: "text-slate-900",
  },
  {
    label: "Naplaćeno",
    value: formatCurrency.format(data.paid),
    valueClass: "text-emerald-700",
  },
  {
    label: "Otvoreno",
    value: formatCurrency.format(data.open),
    valueClass: "text-amber-600",
  },
  {
    label: "Dospjelo",
    value: formatCurrency.format(data.overdue),
    valueClass: "text-rose-600",
  },
];

/** Boja razreda raste s kašnjenjem — nedospjelo je neutralno. */
export const AGING_COLORS: Record<string, string> = {
  Nedospjelo: "text-slate-700",
  "1–30": "text-amber-600",
  "31–60": "text-orange-600",
  "61–90": "text-rose-600",
  "90+": "text-rose-700",
};
